import { render } from "./contactFirst.vue?vue&type=template&id=07153c7b&scoped=true"
import script from "./contactFirst.vue?vue&type=script&lang=js"
export * from "./contactFirst.vue?vue&type=script&lang=js"

import "./contactFirst.vue?vue&type=style&index=0&id=07153c7b&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07153c7b"]])

export default __exports__